// extracted by mini-css-extract-plugin
module.exports = {"wordCountText":"WordCountText__wordCountText___3QyIr"};